import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import vi from './locales/vi.json';

export type AppLanguage = 'en' | 'vi';

export const I18N_LANGUAGE_STORAGE_KEY = 'language';

function normalizeLanguage(language: string | undefined): AppLanguage {
  if (!language) return 'vi';
  const lower = language.toLowerCase();
  if (lower.startsWith('vi')) return 'vi';
  if (lower.startsWith('en')) return 'en';
  return 'vi';
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      vi: { translation: vi },
    },
    supportedLngs: ['en', 'vi'],
    /** Missing keys in vi fall back to en (avoids raw key paths in UI). */
    fallbackLng: ['vi', 'en'],
    interpolation: { escapeValue: false },
    returnNull: false,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: I18N_LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
      convertDetectedLanguage: normalizeLanguage,
    },
  });

if (typeof document !== 'undefined') {
  const setHtmlLang = (lng: string) => {
    document.documentElement.lang = normalizeLanguage(lng);
  };
  setHtmlLang(i18n.resolvedLanguage ?? i18n.language);
  i18n.on('languageChanged', setHtmlLang);
}

export default i18n;
